import { make } from 'vuex-pathify';
import { NotificationSettingService } from '@/modules/global-settings/miscellaneous/services/notification.service';

const notificationSettingsService = new NotificationSettingService();

export const state = {
  newApplicationNotification: {},
  verificationNotification: {},
  watchlistSearchNotification: {},
  confirmationOfPersonOnWatchlistNotification: {},
  complianceReviewNotification: {},
  approvalNotification: {},
  accountCreatedNotification: {},
  deAssignNotification: {},
  assignUserNotification: {},
  terminateApplicationNotification: {},
  denyApplicationNotification: {},
  cancelApplicationNotification: {}
};

export const getters = {
  ...make.getters(state)
};

export const mutations = {
  ...make.mutations(state)
};

export const actions = {
  async fetchOnBoarderNotificationSettings({ commit }) {
    const { data } =
      await notificationSettingsService.getNotificationSettingsByModuleName(
        'On-boarder'
      );
    data.forEach((setting) => {
      if ('new application' === setting.process.name.toLowerCase()) {
        commit('SET_NEW_APPLICATION_NOTIFICATION', setting);
      } else if ('verification' === setting.process.name.toLowerCase()) {
        commit('SET_VERIFICATION_NOTIFICATION', setting);
      } else if ('watchlist search' === setting.process.name.toLowerCase()) {
        commit('SET_WATCHLIST_SEARCH_NOTIFICATION', setting);
      } else if (
        'confirmation of person on watchlist' ===
        setting.process.name.toLowerCase()
      ) {
        commit('SET_CONFIRMATION_OF_PERSON_ON_WATCHLIST_NOTIFICATION', setting);
      } else if ('compliance review' === setting.process.name.toLowerCase()) {
        commit('SET_COMPLIANCE_REVIEW_NOTIFICATION', setting);
      } else if ('approval' === setting.process.name.toLowerCase()) {
        commit('SET_APPROVAL_NOTIFICATION', setting);
      } else if ('account created' === setting.process.name.toLowerCase()) {
        commit('SET_ACCOUNT_CREATED_NOTIFICATION', setting);
      } else if ('de-assign user' === setting.process.name.toLowerCase()) {
        commit('SET_DE_ASSIGN_NOTIFICATION', setting);
      } else if ('assign user' === setting.process.name.toLowerCase()) {
        commit('SET_ASSIGN_USER_NOTIFICATION', setting);
      } else if (
        'terminate application' === setting.process.name.toLowerCase()
      ) {
        commit('SET_TERMINATE_APPLICATION_NOTIFICATION', setting);
      } else if ('deny application' === setting.process.name.toLowerCase()) {
        commit('SET_DENY_APPLICATION_NOTIFICATION', setting);
      } else if ('cancel application' === setting.process.name.toLowerCase()) {
        commit('SET_CANCEL_APPLICATION_NOTIFICATION', setting);
      }
    });
  }
};
